(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ManagementSystemController = (function(superClass) {
    extend(ManagementSystemController, superClass);

    function ManagementSystemController(scope, transitions, modal, http, service, state, anchorScroll, location, timeout) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      this.anchorScroll = anchorScroll;
      this.location = location;
      this.timeout = timeout;
      this.applyFilters = bind(this.applyFilters, this);
      this.fallEnabled = bind(this.fallEnabled, this);
      this.setFilter = bind(this.setFilter, this);
      this.autoScroll = bind(this.autoScroll, this);
      this.setManagementSystemDetails = bind(this.setManagementSystemDetails, this);
      this.setManagementSystem = bind(this.setManagementSystem, this);
      this.openMgmtSystemDialog = bind(this.openMgmtSystemDialog, this);
      ManagementSystemController.__super__.constructor.apply(this, arguments);
      this.filterMap = {
        fallTillage: 'fall_tillage',
        coverCrop: 'cover',
        manure: 'manure',
        fertilizer: 'fertilizer'
      };
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          return Promise.all([_this.http.get("/backend/grower/fieldprint/custom-rotations/" + _this.service.crop), _this.http.get("/backend/grower/fieldprint/crlmod/" + _this.service.crop + "/" + _this.service.field), _this.service.fpcResult.data.management_system ? _this.http.get("/backend/grower/fieldprint/tillage-template/" + _this.service.fpcResult.data.management_system) : void 0]).then(function(responses) {
            var ref;
            return [responses[0].data, responses[1].data, (ref = responses[2]) != null ? ref.data : void 0];
          }).then(function(data) {
            var crlmod, custom, ref, tmt;
            custom = data[0], crlmod = data[1], tmt = data[2];
            _this.crlmod = custom.map(function(c) {
              c.is_custom = true;
              return c;
            }).concat(crlmod);
            if (tmt) {
              tmt.is_tmt = true;
              _this.crlmod.unshift(tmt);
            }
            _this.filteredCrlmod = _this.crlmod.slice();
            if (((ref = _this.service.fpcResult) != null ? ref.data : void 0) != null) {
              if ((_this.service.fpcResult.data.management_system_filters == null) || _this.service.fpcResult.data.management_system_filters.constructor === Array) {
                _this.service.fpcResult.data.management_system_filters = {};
              }
              if (_this.service.fpcResult.data.management_system) {
                _this.setManagementSystemDetails(_this.service.fpcResult.data.management_system);
              } else if (_this.service.fpcResult.data.custom_rot) {
                _this.setManagementSystemDetails(_this.service.fpcResult.data.custom_rot, true);
              } else if (_this.service.fpcResult.data.crlmod) {
                _this.setManagementSystemDetails(_this.service.fpcResult.data.crlmod);
              }
              if ((!_this.service.fpcResult.data.crlmod && !_this.service.fpcResult.data.custom_rot && !_this.service.fpcResult.data.management_system) && _this.service.fpcResult.data.management_system_filters.coverCrop !== _this.service.hasCoverCropEvents()) {
                _this.setFilter('coverCrop', _this.service.hasCoverCropEvents());
              }
              return _this.applyFilters();
            }
          });
        };
      })(this));
      this.scope.uploadCustomRotation = (function(_this) {
        return function(file) {
          var reader;
          if (!file) {
            return;
          }
          reader = new FileReader();
          reader.onload = function() {
            var events, json, ref, ref1, rotObj;
            json = reader.result;
            try {
              rotObj = JSON.parse(json);
            } catch (error) {
              _this.scope.customRotError = 'Invalid file format';
              console.error('Not a correct format');
              return;
            }
            events = (ref = rotObj.managements) != null ? (ref1 = ref[0]) != null ? ref1.events : void 0 : void 0;
            if (!events) {
              _this.scope.customRotError = 'Invalid file format';
              console.error('No events object in json');
              return;
            }
            return _this.http.post('/backend/grower/fieldprint/custom-rotations', {
              name: file.name,
              events: events,
              crop_id: _this.service.fpcResult.ftm_crop.id
            }).then(function(response) {
              var customRot;
              _this.scope.customRotError = '';
              customRot = response.data;
              customRot.is_custom = true;
              _this.crlmod.unshift(customRot);
              _this.service.fpcResult.data.management_system_filters = {};
              _this.applyFilters();
              return _this.setManagementSystem(customRot);
            })["catch"](function(err) {
              _this.scope.customRotError = err.data.message;
              return console.error(err);
            });
          };
          return reader.readAsText(file);
        };
      })(this);
    }

    ManagementSystemController.prototype.openMgmtSystemDialog = function() {
      return this.modal.open({
        windowClass: 'medium_dialog',
        templateUrl: 'backend/grower/fieldprint/mgmt-system-dialog',
        controller: 'DialogController'
      });
    };

    ManagementSystemController.prototype.setManagementSystem = function(system) {
      if (system.is_custom) {
        if (this.service.fpcResult.data.custom_rot === system.id) {
          this.service.fpcResult.data.custom_rot = null;
          return;
        }
        this.service.fpcResult.data.crlmod = null;
        this.service.fpcResult.data.management_system = null;
        this.service.fpcResult.data.custom_rot = system.id;
      } else {
        if (this.service.fpcResult.data.crlmod === system.id) {
          this.service.fpcResult.data.crlmod = null;
          return;
        }
        this.service.fpcResult.data.custom_rot = null;
        this.service.fpcResult.data.management_system = null;
        this.service.fpcResult.data.crlmod = system.id;
      }
      return this.setManagementSystemDetails(system.id, system.is_custom);
    };

    ManagementSystemController.prototype.setManagementSystemDetails = function(management_id, is_custom) {
      var activities, activity, data, k, pieces, v;
      activities = [];
      data = this.crlmod.find((function(_this) {
        return function(management) {
          return +management.id === +management_id && management.is_custom === is_custom;
        };
      })(this)).event_strings;
      for (k in data) {
        v = data[k];
        pieces = v.split(' - ');
        activity = {
          season: pieces[0],
          activity: pieces[1]
        };
        activities.push(activity);
      }
      this.managementSystemDetails = activities;
      return this.autoScroll();
    };

    ManagementSystemController.prototype.autoScroll = function() {
      return this.timeout((function(_this) {
        return function() {
          var newHash;
          if (!_this.service.fpcResult.data.crlmod && !_this.service.fpcResult.data.custom_rot && !_this.service.fpcResult.data.management_system) {
            return;
          }
          if (_this.service.fpcResult.data.management_system != null) {
            newHash = "managementSystem" + _this.service.fpcResult.data.management_system + "tmt";
          } else if (_this.service.fpcResult.data.custom_rot != null) {
            newHash = "managementSystem" + _this.service.fpcResult.data.custom_rot + "cr";
          } else {
            newHash = "managementSystem" + _this.service.fpcResult.data.crlmod;
          }
          if (_this.location.hash() !== newHash) {
            return _this.location.hash(newHash);
          } else {
            return _this.anchorScroll();
          }
        };
      })(this));
    };

    ManagementSystemController.prototype.setFilter = function(filter, selection) {
      var ref, ref1, ref2;
      if (selection === this.service.fpcResult.data.management_system_filters[filter]) {
        this.service.fpcResult.data.management_system_filters[filter] = null;
      } else {
        this.service.fpcResult.data.management_system_filters[filter] = selection;
      }
      if (filter === 'tillageSystem' && ((ref = this.service.fpcResult.data.management_system_filters) != null ? ref.tillageSystem : void 0) === null || ((ref1 = this.service.fpcResult.data.management_system_filters) != null ? ref1.tillageSystem : void 0) === 'no-till') {
        if ((ref2 = this.service.fpcResult.data.management_system_filters) != null) {
          ref2.fallTillage = null;
        }
      }
      return this.applyFilters();
    };

    ManagementSystemController.prototype.fallEnabled = function() {
      var ref, ref1, ref2, ref3;
      return ((ref = this.service.fpcResult.data) != null ? (ref1 = ref.management_system_filters) != null ? ref1.tillageSystem : void 0 : void 0) === null || ((ref2 = this.service.fpcResult.data) != null ? (ref3 = ref2.management_system_filters) != null ? ref3.tillageSystem : void 0 : void 0) === 'no-till';
    };

    ManagementSystemController.prototype.applyFilters = function() {
      this.filteredCrlmod = this.crlmod.filter((function(_this) {
        return function(management) {
          var k, managementKey, ref, v;
          ref = _this.service.fpcResult.data.management_system_filters;
          for (k in ref) {
            v = ref[k];
            if (v === null) {
              continue;
            }
            if (k === 'tillageSystem') {
              if (!management.tillage_class.toLowerCase().includes(v.toLowerCase())) {
                return false;
              }
            } else {
              managementKey = _this.filterMap[k];
              if (management[managementKey] !== v) {
                return false;
              }
            }
          }
          return true;
        };
      })(this));
      if (_.filter(this.filteredCrlmod, {
        id: this.service.fpcResult.data.crlmod
      }).length === 0) {
        this.service.fpcResult.data.crlmod = null;
      }
      return this.autoScroll();
    };

    return ManagementSystemController;

  })(Controller);

}).call(this);
